export const SecondReviewOrderBy = [
  {
    key: 1,
    value: 'FamilyNumber',
    text: 'Family Number',
  },
  {
    key: 2,
    value: 'InitialApplicationDT',
    text: 'Original Application Date',
  },
  {
    key: 3,
    value: 'InitalUsername',
    text: 'Original Application Username',
  },
  {
    key: 4,
    value: 'InitialStatus',
    text: 'Original Status',
  },
  {
    key: 5,
    value: 'ReviewDT',
    text: 'Second Review Date',
  },
  {
    key: 6,
    value: 'ReviewStatus',
    text: 'Second Review Status',
  },
  {
    key: 7,
    value: 'ReviewUsername',
    text: 'Second Review Username',
  },
];



// WEBPACK FOOTER //
// ./src/pages/secondreviewdetails/helpers/constants.js